import { onboardingStatusDTOSchema } from '@instanexus/contracts';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const onboardingStatusEnvelopeSchema = dataEnvelopeSchema(onboardingStatusDTOSchema);
export function createOnboardingResource(transport) {
    return {
        async status() {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/onboarding/status`,
                schema: onboardingStatusEnvelopeSchema,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=onboarding.js.map